import React from "react";
import { ArrowDown } from "lucide-react";
import { PRODUCT, TAGLINE } from "../config/product";

const priceStr = (n) => n.toFixed(2).replace(".", ",");

const Hero = ({ onCTAClick }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-between pt-32 pb-16 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto w-full">
        <div className="max-w-2xl">
          <div className="flex flex-col gap-8">
            <div className="flex items-center gap-3 fade-up" style={{ animationDelay: "0.2s" }}>
              <span className="w-2 h-2 rounded-full bg-[#ff9eeb] animate-pulse" />
              <span className="font-body text-xs tracking-[0.3em] uppercase text-white/60">
                Carga inteligente · USB-C 140W
              </span>
            </div>

            <h1
              data-testid="hero-title"
              className="font-display text-[14vw] md:text-[9vw] lg:text-[7rem] leading-[0.85] font-extrabold tracking-tighter fade-up"
              style={{ animationDelay: "0.4s" }}
            >
              Se apaga
              <br />
              <span className="holo-text">al 100%.</span>
            </h1>

            <p
              data-testid="hero-subtitle"
              className="font-serif-accent text-2xl md:text-3xl text-white/80 max-w-2xl fade-up leading-snug"
              style={{ animationDelay: "0.6s" }}
            >
              {TAGLINE} Corta la corriente cuando tu dispositivo termina de cargar,
              para que no se quede enchufado de más mientras duermes.
            </p>

            <div className="fade-up flex flex-wrap items-center gap-6" style={{ animationDelay: "0.8s" }}>
              <button
                data-testid="hero-cta-btn"
                onClick={onCTAClick}
                className="group relative px-7 py-4 bg-white text-black rounded-full font-body font-medium hover:scale-95 transition-transform duration-300"
              >
                <span className="relative z-10">Comprar · {priceStr(PRODUCT.priceEur)}€</span>
              </button>
              <button
                data-testid="hero-explore-btn"
                onClick={() => document.getElementById("como-funciona")?.scrollIntoView({ behavior: "smooth" })}
                className="px-6 py-4 rounded-full border border-white/20 text-white/90 font-body hover:border-white/60 hover:bg-white/5 transition-all duration-300 flex items-center gap-2"
              >
                Cómo funciona
              </button>
              {PRODUCT.compareAtEur > PRODUCT.priceEur && (
                <span className="font-body text-white/40 line-through text-lg">
                  {priceStr(PRODUCT.compareAtEur)}€
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto w-full flex items-end justify-between gap-8 mt-10">
        <div className="fade-up flex items-center gap-2 text-white/40 text-xs font-body uppercase tracking-widest" style={{ animationDelay: "1s" }}>
          <ArrowDown size={14} className="animate-bounce" />
          Baja para ver más
        </div>
        <div className="font-serif-accent text-white/15 text-7xl md:text-9xl pointer-events-none select-none">
          01
        </div>
      </div>
    </section>
  );
};

export default Hero;
